const mapApiUrl = 'https://maps.googleapis.com/maps/api/js';

export function initMapScript() {
  if (window.google) return Promise.resolve();

  if (document.querySelector('script[src*="maps.googleapis.com"]')) {
    return new Promise((resolve) => {
      const previous = window.initMap;
      window.initMap = () => {
        if (previous) previous();
        resolve();
      };
    });
  }

  return new Promise((resolve) => {
    window.initMap = resolve;
    const src = `${mapApiUrl}?key=${process.env.GOOGLE_API_BROWSER_KEY}&libraries=places&language=fr&callback=initMap`;
    loadAsyncScript(src);
  });
}

function loadAsyncScript(src) {
  const script = document.createElement('script');
  Object.assign(script, {
    type: 'text/javascript',
    async: true,
    src
  });
  document.head.appendChild(script);
}
